<template>
  <div>
    <!-- Header Area -->
    <header class="main_header_area mha_2 col-15">
      <div class="container">
        <div class="header_menu">
          <nav class="navbar navbar-expand-lg">
            <a class="navbar-brand" href="/">
              <img src="images/logo.png" alt="Logo GPI Seguros" />
              <img src="images/logo-2.png" alt="Logo GPI Seguros" />
            </a>
            <!-- Small Divice Menu-->
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target=".navbar_supported"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i class="fa fa-bars" aria-hidden="true"></i>
            </button>

            <div
              class="collapse navbar-collapse navbar_supported"
              v-if="useCreateAccount == true"
            >
              <ul class="navbar-nav">
                <li><a href="/">Inicio</a></li>
                <li>
                  <a class="active" href="/create-account">Crear cuenta</a>
                </li>
                <li class="apply_right">
                  <a class="theme_btn" href="/login">Iniciar sesión</a>
                </li>
              </ul>
            </div>

            <div class="navbar_supported collapse navbar-collapse col" v-else>
              <ul class="navbar-nav ">
                <li class=""><a href="/">Inicio </a></li>
                <li class=""><a href="/pdfGrayZone">Perfil </a></li>
                <li class="">
                  <a href="/GrayZone">Formulario</a>
                </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown"
                    href="#"
                    id="navSolicitud"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Solicitar
                  </a>
                  <ul
                    class="dropdown-menu dropdown-menu-dark"
                    aria-labelledby="navSolicitud"
                  >
                    <li><a v-on:click="aval()">Aval</a></li>
                    <li>
                      <a v-on:click="obligado()">Obligado solidario</a>
                    </li>
                  </ul>
                </li>
                <li v-if="asesor" class="nav-item dropdown ">
                  <a
                    class="nav-link dropdown "
                    href="#"
                    id="navContrato"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Contrato
                  </a>

                  <ul
                    class="dropdown-menu dropdown-menu-dark active"
                    aria-labelledby="navContrato "
                  >
                    <li class="nav-item dropdown ">
                      <a
                        class="nav-link dropdown"
                        href="#"
                        id="SubMenuCredito"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="true"
                      >
                        Credito
                      </a>
                      <ul
                        class="dropdown-menu dropdown-menu-dark"
                        aria-labelledby="SubMenuCredito"
                      >
                        <li>
                          <button
                            class="col border btn"
                            v-on:click="
                              contratos('/ContratoCredito?type=basic')
                            "
                            method="GET"
                          >
                            Tradicional
                          </button>
                        </li>
                        <li>
                          <button
                            class="col border btn"
                            v-on:click="
                              contratos('/ContratoEmpleado?type=basic')
                            "
                            method="GET"
                          >
                            Empleado
                          </button>
                        </li>
                        <li>
                          <button
                            class="col border btn"
                            v-on:click="
                              contratos('/ContratoCredito?type=endorsement')
                            "
                            method="GET"
                          >
                            Aval
                          </button>
                        </li>
                        <li>
                          <button
                            class="col border btn"
                            v-on:click="
                              contratos('/ContratoCredito?type=bound')
                            "
                            method="GET"
                          >
                            Obligado Solidario
                          </button>
                        </li>
                        <li>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoCredito?type=both')"
                            method="GET"
                          >
                            Aval y Obligado Solidario
                          </button>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item dropdown ">
                      <a
                        class="nav-link dropdown"
                        href="#"
                        id="SubMenuArrendamiento"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="true"
                      >
                        Arrendamiento Fisico
                      </a>
                      <ul
                        class="dropdown-menu dropdown-menu-dark "
                        aria-labelledby="SubMenuArrendamiento"
                      >
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=ABasic')"
                            method="GET"
                          >
                          ARRENDAMIENTO FISICO
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=Aendorsement')"
                            method="GET"
                          >
                          AVAL
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=Abound')"
                            method="GET"
                          >
                          DEUDOR SOLIDARIO
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=About')"
                            method="GET"
                          >
                          DEUDOR SOLIDARIO y AVAL
                          </button>

                      </ul>
                    </li>
                    <li class="nav-item dropdown ">
                      <a
                        class="nav-link dropdown"
                        href="#"
                        id="SubMenuArrendamiento"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="true"
                      >
                        Arrendamiento Moral
                      </a>
                      <ul
                        class="dropdown-menu dropdown-menu-dark "
                        aria-labelledby="SubMenuArrendamiento"
                      >
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=Amoral')"
                            method="GET"
                          >
                          ARRENDAMIENTO MORAL
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=AmoralAendorsement')"
                            method="GET"
                          >
                          AVAL
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=AmoralAbound')"
                            method="GET"
                          >
                          DEUDOR SOLIDARIO
                          </button>
                          <button
                            class="col border btn"
                            v-on:click="contratos('/ContratoArrendamiento?type=Amoralfull')"
                            method="GET"
                          >
                          DEUDOR SOLIDARIO y AVAL
                          </button>

                      </ul>
                    </li>
                    <li class="nav-item dropdown ">
                      <a
                        class="nav-link dropdown"
                        href="#"
                        id="SubMenuCredito"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="true"
                      >
                        Extras
                      </a>
                      <ul
                        class="dropdown-menu dropdown-menu-dark"
                        aria-labelledby="SubMenuCredito"
                      >
                        <!-- Mandamos a llamar los datos personalizados -->
                        <li>
                          <button class="col border btn" method="GET">
                            <li>
                              <a
                                href="/ContratoFactura"
                                name="datos_facturacion"
                                >Facturacion</a
                              >
                            </li>
                          </button>
                        </li>
                        <li>
                          <button class="col border btn" method="GET">
                            <li>
                              <a href="/ContratoExtras" name="datos_gps"
                                >Formato GPS</a
                              >
                            </li>
                          </button>
                        </li>
                        <li>
                          <button class="col border btn" method="GET">
                            <li>
                              <a href="/CartaFactura"
                                 name="carta_factura">
                                Carta factura</a>
                            </li>
                          </button>
                        </li>
                        <li>
                          <button class="col border btn" method="GET">
                            <li>
                              <a href="/CaratulaCredito"
                                 name="CaratulaCredito">
                                 Caratula Credito</a>
                            </li>
                          </button>
                        </li>
                        <li>
                          <button class="col border btn" method="GET">
                            <li>
                              <a href="/PagareFederatario"
                                 name="PagareFederatario">
                                 Pagare Federatario</a>
                            </li>
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="navbar-nav">
                <li class="apply_right" v-if="useApplyNow === false">
                  <a
                    class="theme_btn"
                    style="cursor: pointer"
                    v-on:click="logout()"
                    >Cerrar sesión</a
                  >
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
    <!-- Header Area -->
  </div>
</template>

<script>
import {
  required,
  minLength,
  between,
  maxValue,
  minValue,
  email
} from "vuelidate/lib/validators";

var regexEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
var regexPhone = /[0-9]{10}$/;

export default {
  name: "Menu",
  data() {
    return {
      email: "",
      phone: "",
      asesor: false
    };
  },
  validations() {
    return {
      email: {
        required,
        validateEmail: value => {
          return regexEmail.test(value);
        }
      },
      phone: { required }
    };
  },
  props: {
    useApplyNow: {
      type: Boolean,
      default: true
    },
    useCreateAccount: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logout() {
      this.$SessionService.logout().then(
        result => {
          localStorage.removeItem("session");
          localStorage.removeItem("id");
          localStorage.removeItem("confirmationData");
          localStorage.removeItem("quote_credit");
          location.reload();
          this.useApplyNow = true;
        },
        err => alert(err.msg)
      );
    },
    aval() {
      this.$swal.fire({
        title: "Registro de aval",
        html:
          '<label class="swal2-label">Correo del aval</label></br>' +
          '<input id="swal-correo" name="swal-correo" type="email" class="swal2-input"><br>' +
          '<label class="swal2-label">Telefono del aval</label>' +
          '<input id="swal-telefono" name="swal-telefono"' +
          'type="number" class="swal2-input" maxlength="10" minlength="10">',
        confirmButtonText: "Enviar solicitud",
        focusConfirm: false,
        preConfirm: () => {
          let correo = document.getElementById("swal-correo").value;
          let telefono = document.getElementById("swal-telefono").value;

          if (!regexEmail.test(correo) || !regexPhone.test(telefono)) {
            this.$swal("CUIDADO!", "Los datos no son validos", "error").then(
              result => {
                this.aval();
              }
            );
          } else {
            this.$UserService.getUser().then(
              result => {
                if (result.data.length > 0) {
                  var html =
                    `El cliente <b>${result.data[0].name}</b> a solicitado un credito automotriz` +
                    `<br>para continuar con el proceso requiere que te registres como su aval` +
                    `<br><br><b>Registro de aval.</b>` +
                    `<br><b>Sigue los siguientes pasos:</b>` +
                    `<br>&emsp;&emsp;<b>1. </b>Ingresa a <b>www.gpiautocomercial.com</b> ` +
                    `<br>&emsp;&emsp;<b>2. </b>Con el correo <b>${correo}</b>` +
                    `<br>&emsp;&emsp;<b>3. </b>Contraseña <b>${result.data[0].clave_asesor}${telefono}</b>` +
                    `<br>&emsp;&emsp;<b>4. </b>Llene la informacion que se le solicta en cada paso` +
                    ``;
                  let subject = "Crédimovil - Solicitud de aval";
                  let data = {
                    email: correo,
                    password: "aval".clave_asesor + telefono,
                    phone: telefono,
                    clave_asesor: result.data[0].clave_asesor,
                    tipo: "Aval",
                    usuario_padre: localStorage.getItem("id")
                  };
                  this.$SessionService.register(data).then(
                    result => {
                      this.$UtilityService
                        .sendEmail(html, subject, correo)
                        .then(
                          result => {
                            this.$swal(
                              "¡Gracias!",
                              "Un asesor se pondra un cóntacto con: <br><b>" +
                                correo +
                                "</b>",
                              "success"
                            );
                          },
                          err => {
                            this.$swal("1CUIDADO!", err.msg, "error");
                            console.log("---> ", err);
                          }
                        );
                    },
                    err => this.$swal("2CUIDADO!", err.msg, "error")
                  );
                }
              },
              err => {
                this.$swal("3CUIDADO!", err.msg, "error");
                this.preloaderHiden();
              }
            );
          }

          //return null;
        }
      });
    },
    obligado() {
      this.$swal.fire({
        title: "Registro de obligado solidario",
        html:
          '<label class="swal2-label">Correo del obligado solidario</label></br>' +
          '<input id="swal-correo" name="swal-correo" type="email" class="swal2-input"><br>' +
          '<label class="swal2-label">Telefono del obligado solidario</label>' +
          '<input id="swal-telefono" name="swal-telefono"' +
          'type="number" class="swal2-input" maxlength="10" minlength="10">',
        confirmButtonText: "Enviar solicitud",
        focusConfirm: false,
        preConfirm: () => {
          let correo = document.getElementById("swal-correo").value;
          let telefono = document.getElementById("swal-telefono").value;

          if (!regexEmail.test(correo) || !regexPhone.test(telefono)) {
            this.$swal("CUIDADO!", "Los datos no son validos", "error").then(
              result => {
                this.obligado();
              }
            );
          } else {
            this.$UserService.getUser().then(
              result => {
                if (result.data.length > 0) {
                  var html =
                    `El cliente <b>${result.data[0].name}</b> a solicitado un credito automotriz` +
                    `<br>para continuar con el proceso requiere que te registres como su aval` +
                    `<br><br><b>Registro de aval.</b>` +
                    `<br><b>Sigue los siguientes pasos:</b>` +
                    `<br>&emsp;&emsp;<b>1. </b>Ingresa a <b>www.gpiautocomercial.com</b> ` +
                    `<br>&emsp;&emsp;<b>2. </b>Con el correo <b>${correo}</b>` +
                    `<br>&emsp;&emsp;<b>3. </b>Contraseña <b>Obs${telefono}</b>` +
                    `<br>&emsp;&emsp;<b>4. </b>Llene la informacion que se le solicta en cada paso` +
                    ``;
                  let subject = "Crédimovil - Solicitud de Obligado solidario";
                  let data = {
                    email: correo,
                    password: "Obs" + telefono,
                    phone: telefono,
                    clave_asesor: result.data[0].clave_asesor,
                    tipo: "Obligado solidario",
                    usuario_padre: localStorage.getItem("id")
                  };
                  this.$SessionService.register(data).then(
                    result => {
                      this.$UtilityService
                        .sendEmail(html, subject, correo)
                        .then(
                          result => {
                            this.$swal(
                              "¡Gracias!",
                              "Un asesor se pondra un cóntacto con: <br><b>" +
                                correo +
                                "</b>",
                              "success"
                            );
                          },
                          err => {
                            this.$swal("CUIDADO!", err.msg, "error");
                            console.log("---> ", err);
                          }
                        );
                    },
                    err => this.$swal("CUIDADO!", err.msg, "error")
                  );
                }
              },
              err => {
                this.$swal("CUIDADO!", err.msg, "error");
                this.preloaderHiden();
              }
            );
          }

          //return null;
        }
      });
    },
    contratos(url) {
      this.$swal.fire({
        title: "Datos del contrato",
        html:
          '<label class="swal2-label">Fecha del primer pago</label></br>' +
          '<input id="swal-pago" name="swal-pago" type="date" class="swal2-input"><br>' +
          '<label class="swal2-label">Periodo</label><br>' +
          '<select id="swal-tasa" name="swal-tasa"' +
          'class="swal2-input">' +
          "<option value='2.32'>2.32% Tradicional</option>" +
          "<option value='2.50'>2.50% Tradicional</option>" +
          "<option value='2.70'>2.70% Tradicional</option>" +
          "<option value='2.16'>2.16% Especial Dir Comercial</option>" +
          "<option value='2.00'>2.00% Especial Dir General</option>" +
          "<option value='2.90'>2.90% MTMR</option>" +
          "<option value='2.60'>2.60% Tradicional</option>" +
          "<option value='2.40'>2.40% Tradicional</option>" +
          "<option value='3.75'>3.75% Tradicional</option>" +
          "<option value='3.00'>3.00% Empleado</option>" +
          "<option value='2.0184'>2.02% BETA</option>" +
          "<option value='2.1576'>2.16% BETA</option>" +
          "<option value='2.3200'>2.32% BETA</option>" +
          "</select><br>"+
          'GPS <input id="swal-gps" name="swal-gps" type="checkbox" class="swal2-input" checked="checked">'+
          'SDD<input id="swal-sdd" name="swal-sdd" type="checkbox" class="swal2-input" checked="checked"><br>'+
          'C Apertura <input id="swal-capertura" name="swal-capertura" type="checkbox" class="swal2-input" checked="checked">'+
          'C Lote <input id="swal-clote" name="swal-clote" type="checkbox" class="swal2-input" checked="checked"><br>',
        confirmButtonText: "Generar contrato",
        focusConfirm: false,
        preConfirm: () => {
          let pago = document.getElementById("swal-pago").value;
          let tasa = document.getElementById("swal-tasa").value;
          let gps = document.getElementById("swal-gps").checked;
          let sdd = document.getElementById("swal-sdd").checked;
          let capertura = document.getElementById("swal-capertura").checked;
          let clote = document.getElementById("swal-clote").checked;

          if (pago == "" || tasa == "") {
            this.$swal("CUIDADO!", "Los datos no son validos", "error").then(
              result => {
                this.contratos();
              }
            );
          } else {
            this.preloader();
            this.$UserService.updateFromTaskClickUp()
            .then( result => {
              this.$BancoService.createNumOperacion()
              .then(result => {
                  this.$UserService.getCreditQuotation()
                  .then(result => {
                    if (result.data.length > 0) {
                      let date_first = new Date(pago);
                      let date_last = new Date(pago);
                      let data = {
                        data: {
                          fecha_primer_pago: date_first,
                          fecha_ultimo_pago: new Date(
                            date_last.setMonth(
                              date_last.getMonth() + Number(result.data[0].months)
                            )
                          ),
                          dia_pago: date_first.getDate() + 1,
                          tasa: tasa,
                          gps:gps,
                          sdd:sdd,
                          capertura:capertura,
                          clote:clote
                        }
                      };
                      this.$UserService.updateContract(data).then(result => {
                        this.preloaderHiden();
                        window.location.href = url;
                      });
                    }
                  });
                },
                err => {
                  console.log(err);
                  this.$swal("CUIDADO!", err.msg, "error");
                  this.preloaderHiden();
                }
              );
            },
                err => {
                  console.log(err);
                  this.$swal("CUIDADO!", err.msg, "error");
                  this.preloaderHiden();
                });
          }
        }
      });

    },
    menuTipo() {
      let tipo = localStorage.getItem("tipo");
      if (tipo == "ACESOR") {
        this.asesor = true;
      }
    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    this.menuTipo();
  }
};
</script>

<style lang="scss">
.swal2-container {
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuSolicitud.vue